// ============================================================
// FADE-IN SECTIONS (Intersection Observer)
// ============================================================
document.addEventListener("DOMContentLoaded", function () {
  const fadeSections = document.querySelectorAll(".fade-in-section");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.4 }
  );

  fadeSections.forEach((section) => observer.observe(section));
});

// ============================================================
// NEWSLETTER IN FOOTER
// ============================================================
var form = document.getElementById('footer-newsletter');
if (form) {
  var KLAVIYO_PUBLIC_KEY = 'VtvQ7t'; // Klaviyo → Settings → API Keys
  var KLAVIYO_LIST_ID = 'XrSXar';    // Klaviyo → Audience → Lists & Segments → lijst → Settings

  var input = form.querySelector('[name="email"]');
  var btn = form.querySelector('.site-footer__newsletter-btn');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = input.value.trim();
    if (!email) return;

    btn.disabled = true;

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2026-07-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: {
                    email: { marketing: { consent: 'SUBSCRIBED' } }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: { type: 'list', id: KLAVIYO_LIST_ID }
            }
          }
        }
      })
    })
    .then(function (res) {
      if (res.ok) {
        showSuccess();
      } else {
        showError();
      }
    })
    .catch(function () {
      showError();
    });
  });

  function showSuccess() {
    input.value = '';
    input.placeholder = 'Bedankt voor je aanmelding!';
    input.disabled = true;
    btn.style.display = 'none';
    input.classList.add('is-success');
  }

  function showError() {
    btn.disabled = false;
    input.placeholder = 'Er ging iets mis, probeer opnieuw';
    input.classList.add('is-error');
  }
}